/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { StaticContext } from 'react-router';
import { Icon, Responsive } from 'vendors/semantic-ui';
import { useSelector } from 'react-redux';

import { configUI } from 'config/config-ui';
import { RootState } from 'modules/shared/redux/store';
import { SidebarLayout } from 'modules/shared/layouts';
import { useRouter } from 'modules/shared/hooks';
import { LightProduct } from '../../../models';

import { VerticalProductList } from '../vertical-product-list';
import { ProductFilterList, ProductSortList, ProductSortType } from './components';

import { Props } from './filterable-product-list-type';

import styles from './filterable-product-list-component.module.css';

export const FilterableProductList: React.FC<Props> = React.memo(
    ({ products, selectedSort, handleSortSelection, ...rest }: Props) => {
        if (!products) {
            return <React.Fragment />;
        }

        let sortedProducts: LightProduct[] = [];
        switch (selectedSort) {
            case 1:
                sortedProducts = products.sort((a, b) => a.price - b.price);
                break;
            case 2:
                sortedProducts = products.sort((a, b) => b.price - a.price);
                break;
            case 3:
                sortedProducts = products.sort((a, b) => (a.name > b.name ? 1 : -1));
                break;
            default:
                sortedProducts = products;
                break;
        }

        const { history, location } = useRouter<{}, StaticContext, { sidebarVisibility?: boolean }>();
        const toggleSideBar = (visibility: boolean): void => {
            history.replace({ ...location, state: { ...location.state, sidebarVisibility: visibility } });
        };
        const sideBarIsVisible: boolean = location && location.state && !!location.state.sidebarVisibility;
        const headerHeight = useSelector<RootState, number>(state => {
            return state && state.layout ? state.layout.headerHeight : 0;
        });

        return (
            <SidebarLayout
                mobileHeaderComponent={
                    <div className={styles.filtersContainer} style={{ top: headerHeight }}>
                        <div
                            className={styles.filterBtn}
                            onClick={() => toggleSideBar(!sideBarIsVisible)}
                            role="presentation"
                        >
                            <span>Filtres</span>
                            <Icon size="small" name="filter" />
                        </div>
                        <ProductSortList
                            selectedValue={selectedSort as ProductSortType}
                            handleSortSelection={handleSortSelection}
                        />
                    </div>
                }
                sideComponent={<ProductFilterList {...rest} />}
                contentComponent={
                    <VerticalProductList
                        products={sortedProducts}
                        headerChildren={
                            <Responsive as={React.Fragment} minWidth={configUI.responsive.tablet.minWidth}>
                                <ProductSortList
                                    selectedValue={selectedSort as ProductSortType}
                                    handleSortSelection={handleSortSelection}
                                />
                            </Responsive>
                        }
                    />
                }
            />
        );
    },
);
